import { useCallback, useEffect, useState } from 'react';
import { recordItemEvent } from '../api';

const STORAGE_KEY = 'jewelry.wishlist';

function readStoredIds() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

// Local, device-scoped wishlist (user story 3.1: "local/session wishlist works for guests too").
// Backend persistence across devices (story 3.2) is a separate, later piece of work - this keeps
// the ♡ toggle instant and working with no account required, per the feed's UX requirements.
export function useWishlist() {
  const [ids, setIds] = useState(readStoredIds);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const has = useCallback((itemId) => ids.includes(itemId), [ids]);

  const toggle = useCallback((itemId) => {
    setIds((prev) => {
      const already = prev.includes(itemId);
      if (already) return prev.filter((id) => id !== itemId);
      // Only record the "wishlist" engagement signal on add, not remove - a removal isn't
      // renewed interest.
      recordItemEvent(itemId, 'wishlist');
      return [...prev, itemId];
    });
  }, []);

  return { ids, has, toggle };
}
